module.exports = __webpack_public_path__ + "static/media/itatiaia-rj.04c271b2.jpg";